import React from "react";
import type { LucideIcon } from "lucide-react";
import { Link } from "@remix-run/react";

type SpaceTypeLinkingFeatureCardProps = {
  icon: LucideIcon | string;
  title: string;
  description: string;
  className?: string;
  id?: string;
  spaceType: string;
  price: string;
  linkText: string;
  href?: string;
};

export function SpaceTypeLinkingFeatureCard({
  icon: Icon,
  title,
  description,
  spaceType,
  price,
  linkText,
  href,
  className = "",
  id,
}: SpaceTypeLinkingFeatureCardProps) {
  return (
    <div
      id={id}
      className={`flex flex-col sm:flex-row items-stretch overflow-hidden sm:rounded-lg sm:border sm:border-gray-50 bg-white -mx-4 md:mx-0 ${className}`}
    >
      <div className='grid items-center bg-gray-50 p-4 sm:p-6 md:p-8 text-sm leading-5 text-oh-black'>
        <h2 className="font-semibold text-lg mb-2">{title}</h2>
        <div dangerouslySetInnerHTML={{ __html: description as string }} className='text-justify' />
        <Link
          to={href}
          className='text-oh-black font-bold underline mt-4'
          data-spinner="true"
        >
          ⟶ {"   "} {linkText}
        </Link>
      </div>
      <div className='flex sm:w-48 shrink-0 flex-col items-center justify-center gap-2 p-6 sm:p-10'>
        {typeof Icon === 'string' ? (
          <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-gray-50'>
            <img src={Icon} alt={title} className='h-8 w-8 object-contain ' />
          </div>
        ) : (
          <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-gray-50 text-oh-black'>
            <Icon className='h-8 w-8 text-oh-primary' />
          </div>
        )}
        <div className='text-base font-medium text-center text-oh-tertiary'>{price}</div>
        <div className='text-xs font-medium text-center text-gray-400'>{spaceType}</div>
      </div>
    </div>
  );
}
